"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumber = void 0;
const InvalidPhoneNumber_1 = __importDefault(require("../../Errors/InvalidPhoneNumber"));
class PhoneNumber {
    constructor(value) {
        this.value = value;
        this.value = this.cleanAndFormat(value);
    }
    cleanAndFormat(value) {
        if (typeof value !== 'string') {
            throw new InvalidPhoneNumber_1.default(`Expected a string, got (${typeof value})`, 400);
        }
        const cleanedValue = value.trim().replace(/(?!^\+)\D/g, ''); // Remove non-digit characters but keep an initial plus sign
        if (cleanedValue.length < 5) {
            throw new InvalidPhoneNumber_1.default(`Phone number is too short. Got (${value}).`, 400);
        }
        if (cleanedValue.length > 20) {
            throw new InvalidPhoneNumber_1.default(`Phone number is too long. Got (${value}).`, 400);
        }
        if (cleanedValue.startsWith('+')) {
            return cleanedValue;
        }
        if (cleanedValue.startsWith('44')) {
            return '+' + cleanedValue;
        }
        if (cleanedValue.startsWith('044')) {
            return '+' + cleanedValue.slice(1);
        }
        if (cleanedValue.startsWith('0044')) {
            return '+' + cleanedValue.slice(2);
        }
        return '+44' + cleanedValue;
    }
    static create(value) {
        return new this(value);
    }
    equals(otherPhone) {
        return this.value === otherPhone.value;
    }
    toString() {
        return this.value;
    }
    toJSON() {
        return this.toString();
    }
}
exports.PhoneNumber = PhoneNumber;
exports.default = PhoneNumber;
